import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../api/services"
import { PRICING_SLICE_NAME as SLICE_NAME } from "./pricing.constants"

export const getPricing = createAsyncThunk(
  `${SLICE_NAME}/get_pricing`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getPricing(params)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

export const getAllPricingSchemes = createAsyncThunk(
  `${SLICE_NAME}/get_all_pricing_schemes`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getAllPricingSchemes()

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

export const getPricingFilterOptions = createAsyncThunk(
  `${SLICE_NAME}/get_pricing_filter_options`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getPricingFilterOptions()

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

export const createPricing = createAsyncThunk(
  `${SLICE_NAME}/create_pricing`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.createPricing(data)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

export const updatePricing = createAsyncThunk(
  `${SLICE_NAME}/update_pricing`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.updatePricing(data)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

export const deletePricing = createAsyncThunk(
  `${SLICE_NAME}/delete_pricing`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deletePricing(id)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return id
  }
)

export const getLookupPricing = createAsyncThunk(
  `${SLICE_NAME}/get_lookup_pricing`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getLookupPricing(params)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

export const getLookupPricingFilterOptions = createAsyncThunk(
  `${SLICE_NAME}/get_lookup_pricing_filter_options`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getLookupPricingFilterOptions()

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

// Every scheme an admin may assign on the merchant pricing page (CHA1-3035), unpaginated; the backend
// narrows it to the whitelist for Admin Partner.
export const getLookupPricingAssignmentOptions = createAsyncThunk(
  `${SLICE_NAME}/get_lookup_pricing_assignment_options`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getLookupPricingAssignmentOptions()

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    return response.data
  }
)

// Create, update and delete also refresh the filter options: the name list follows the schemes.
export const createLookupPricing = createAsyncThunk(
  `${SLICE_NAME}/create_lookup_pricing`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.createLookupPricing(data)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    dispatch(getLookupPricingFilterOptions())
    return response.data
  }
)

export const updateLookupPricing = createAsyncThunk(
  `${SLICE_NAME}/update_lookup_pricing`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.updateLookupPricing(data)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    dispatch(getLookupPricingFilterOptions())
    return response.data
  }
)

export const deleteLookupPricing = createAsyncThunk(
  `${SLICE_NAME}/delete_lookup_pricing`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deleteLookupPricing(id)

    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }

    dispatch(getLookupPricingFilterOptions())
    return id
  }
)
